import { allFeaturesAtFalse, type Features } from './default'

export const features: Features = {
  ...allFeaturesAtFalse,
  home: {
    ...allFeaturesAtFalse.home,
    advantages: true,
  },
  contact: {
    mailTo: 'contact.moulins.soufflet@episens.fr',
    hubspot: {
      formId: 'ee03ac86-9933-49b0-8950-013a3fc28d3e',
      portalId: '145811218',
    },
  },
  newsletter: {
    hubspot: {
      formId: '6a196b95-f3d0-4874-a947-783214980fa6',
      portalId: '145811218',
    },
  },
  footer: {
    ...allFeaturesAtFalse.footer,
    social: {
      facebook: 'https://www.facebook.com/MoulinsSoufflet/',
      linkedin: 'https://www.linkedin.com/company/moulinssoufflet/',
      youtube: 'https://www.youtube.com/@EpisensbyInVivo',
      instagram: 'https://www.instagram.com/moulinssoufflet/',
    },
  },
  checkoutV2: {
    displayMention: true,
    displayToBeCalulated: true,
    displayCutOffMessage: true,
  },
  pdp: {
    templateB2AGFeature: false,
    showOnlyMainImage: false,
    showSupplier: true,
  },
  platform: {
    name: 'Episens',
  },
  inLanguage: 'fr-FR',
  webSite: {
    name: 'Episens | Vente en ligne de produits pour les artisans boulangers',
    url: 'https://espace-client.episens.fr/',
    searchTargetUrl: 'https://espace-client.episens.fr/products?query={search_term_string}',
  },
}
